import { useState } from 'react';
import loadable from '@loadable/component';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { useIsMobileScreen } from '@/hooks/useMedia';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

const HoldingsActionSheet = loadable(() => import('../Overlays'), {
  resolveComponent: (c) => c.HoldingsActionSheet,
});

const HoldingsModal = loadable(() => import('../Overlays'), {
  resolveComponent: (c) => c.HoldingsModal,
});

export type ManualPortfolioState = 'add' | 'edit' | 'confirm';

export const CreateManualPortfolio = ({ onClose }: { onClose: () => void }) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const [manualPortfolioState, setManualPortfolioState] =
    useState<ManualPortfolioState>('add');
  const [portfolioId, setPortfolioId] = useState<Portfolio['id'] | null>(null);

  return isMobileScreen ? (
    <HoldingsModal
      portfolioId={portfolioId}
      setPortfolioId={setPortfolioId}
      manualPortfolioState={manualPortfolioState}
      setManualPortfolioState={setManualPortfolioState}
      onClose={onClose}
    />
  ) : (
    <HoldingsActionSheet
      portfolioId={portfolioId}
      setPortfolioId={setPortfolioId}
      manualPortfolioState={manualPortfolioState}
      setManualPortfolioState={setManualPortfolioState}
      onClose={onClose}
    />
  );
};
